import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { TablePlugin } from "@lexical/react/LexicalTablePlugin";
import { AutoFocusPlugin } from "@lexical/react/LexicalAutoFocusPlugin";
import { TrackMediaIdsAndMentionsPlugin } from "./plugins/index.js";
const FunctionalPlugins = (t0)=>{
    const $ = c(22);
    const { config, debouncedOnChange, focusMode, setMediaIds, setMentionsData } = t0;
    let t1;
    if ($[0] !== config.plugins.linkAndTablePlugin.table) {
        t1 = config.plugins.linkAndTablePlugin.table && /*#__PURE__*/ jsx(TablePlugin, {});
        $[0] = config.plugins.linkAndTablePlugin.table;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== config.plugins.linkAndTablePlugin.link) {
        t2 = config.plugins.linkAndTablePlugin.link && /*#__PURE__*/ jsx(LinkPlugin, {
            attributes: {
                target: "_blank"
            }
        });
        $[2] = config.plugins.linkAndTablePlugin.link;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== config.plugins.listAndFormatPlugin.list) {
        t3 = config.plugins.listAndFormatPlugin.list && /*#__PURE__*/ jsx(ListPlugin, {});
        $[4] = config.plugins.listAndFormatPlugin.list;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ jsx(HistoryPlugin, {});
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== config.plugins.trackMediaIdsAndMentionsPlugin || $[8] !== setMediaIds || $[9] !== setMentionsData) {
        t5 = config.plugins.trackMediaIdsAndMentionsPlugin && /*#__PURE__*/ jsx(TrackMediaIdsAndMentionsPlugin, {
            setMediaIds: setMediaIds,
            setMentionsData: setMentionsData
        });
        $[7] = config.plugins.trackMediaIdsAndMentionsPlugin;
        $[8] = setMediaIds;
        $[9] = setMentionsData;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== debouncedOnChange) {
        t6 = /*#__PURE__*/ jsx(OnChangePlugin, {
            onChange: debouncedOnChange,
            ignoreSelectionChange: true
        });
        $[11] = debouncedOnChange;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== focusMode) {
        t7 = "auto" === focusMode && /*#__PURE__*/ jsx(AutoFocusPlugin, {
            defaultSelection: "rootEnd"
        });
        $[13] = focusMode;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
        t8 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t1,
                t2,
                t3,
                t4,
                t5,
                t6,
                t7
            ]
        });
        $[15] = t1;
        $[16] = t2;
        $[17] = t3;
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
};
export { FunctionalPlugins };
